module.exports = __webpack_public_path__ + "img/kl-marathon-1-2018.0fe4c085.png";